import { render, staticRenderFns } from "./excellent.vue?vue&type=template&id=7f719ec5&scoped=true"
import script from "./excellent.vue?vue&type=script&lang=js"
export * from "./excellent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f719ec5",
  null
  
)

export default component.exports